// src/components/Sidebar/components/BannerBlock.jsx
import React, { useState } from "react";
import { Box, Card, CardActionArea, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";

export default function BannerBlock({ onItemClick }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Box sx={{ px: 2, pb: 2 }}>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        overflow: "hidden",
                        border: "1px solid rgba(0,0,0,0.10)",
                        boxShadow: "0 8px 18px rgba(0,0,0,0.10)",
                    }}
                >
                    <CardActionArea onClick={() => setOpen(true)}>
                        <Box component="img" src="/images/banner1.png" alt="산들마켓 이벤트 배너" sx={{ width: "100%", display: "block" }} />
                    </CardActionArea>
                </Card>
            </Box>

            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle sx={{ fontWeight: 900 }}>
                    🎁 이벤트 배너
                    <Typography sx={{ mt: 0.5, fontSize: 12.5, color: "text.secondary", fontWeight: 600 }}>
                        원하시는 곳으로 이동할 수 있어요
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 1.25, mt: 0.5 }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                            window.open("https://xn--6e0bkp381dujj.com/", "_blank");
                            onItemClick?.();
                        }}
                    >
                        🌐 사이트로 이동
                    </Button>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => {
                            window.open("https://open.kakao.com/o/sj4Z0QIh", "_blank");
                            onItemClick?.();
                        }}
                    >
                        💬 카카오톡으로 문의하기
                    </Button>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => setOpen(false)} color="inherit">
                        닫기
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
